module.exports = __webpack_public_path__ + "static/media/18ECA1.98666ee8.jpg";